export default __webpack_public_path__ + "80eb275ceb52a22550480f9ca51c738e.png";